module.exports = __webpack_public_path__ + "img/newspaper.8b1c3a42.png";